import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

// Add new languages here once translate.js has generated them:
// import es from './locales/es.json';
// import fr from './locales/fr.json';

const STORAGE_KEY = '147coach_locale';

const savedLocale = localStorage.getItem(STORAGE_KEY);
const browserLocale = navigator.language.slice(0, 2);

// Supported locales — add to this array when you add a language file above
export const SUPPORTED_LOCALES = ['en'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const LOCALE_LABELS: Record<string, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  pt: 'Português',
  nl: 'Nederlands',
  pl: 'Polski',
  ru: 'Русский',
  zh: '中文',
  ja: '日本語',
  ar: 'العربية',
};

export const LOCALE_FLAGS: Record<string, string> = {
  en: '🇬🇧',
  es: '🇪🇸',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹',
  pt: '🇵🇹',
  nl: '🇳🇱',
  pl: '🇵🇱',
  ru: '🇷🇺',
  zh: '🇨🇳',
  ja: '🇯🇵',
  ar: '🇸🇦',
};

const detectedLocale =
  savedLocale && SUPPORTED_LOCALES.includes(savedLocale as SupportedLocale)
    ? savedLocale
    : SUPPORTED_LOCALES.includes(browserLocale as SupportedLocale)
      ? browserLocale
      : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      // es: { translation: es },
      // fr: { translation: fr },
    },
    lng: detectedLocale,
    fallbackLng: 'en',  // always fall back to English — no blank UI ever
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export function setLocale(locale: string) {
  localStorage.setItem(STORAGE_KEY, locale);
  i18n.changeLanguage(locale);
}

export default i18n;